module.exports = __webpack_public_path__ + "og-image.jpg?fda9d676f55e18b3c9dad364b8a07fa5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/og-image.jpg
// module id = 142
// module chunks = 0